'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('../actions/index');

var _utils = require('../utils');

// The default async action types
/* eslint consistent-return: 0 */
var defaultTypes = [_index.START_USER_PERMISSIONS_TIMER, _index.STOP_USER_PERMISSIONS_TIMER];

var permissionMiddleware = function permissionMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  var timer = null;
  return function (next) {
    return function (action) {
      if (defaultTypes.indexOf(action.type) < 0) {
        return next(action);
      }

      if (action.type === _index.START_USER_PERMISSIONS_TIMER) {
        var payload = action.payload,
            _action$immediately = action.immediately,
            immediately = _action$immediately === undefined ? true : _action$immediately;

        var timerInterval = action.timerInterval || _utils.DEFAULT_TIME_INTERVAL;
        (0, _utils.validateTimerInterval)(timerInterval);

        if (timer) {
          clearInterval(timer);
        }

        var fetchUserPermissions = function fetchUserPermissions() {
          return dispatch(payload);
        };

        var updatePayload = Object.assign({}, payload, { type: _index.UPDATE_USER_PERMISSIONS });
        var updateUserPermissions = function updateUserPermissions() {
          return dispatch(updatePayload);
        };

        timer = setInterval(updateUserPermissions, timerInterval);
        if (immediately) {
          return fetchUserPermissions();
        }
      }

      if (action.type === _index.STOP_USER_PERMISSIONS_TIMER) {
        clearInterval(timer);
      }
    };
  };
};

exports.default = permissionMiddleware;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/components/permissionMiddleware.js
 ** module id = 306
 ** module chunks = 0
 **/